import React from 'react';
import isNil from 'lodash/isNil';
import InvestmentAccountForm from './Forms/InvestmentAccountForm';
import NonInvestmentAccountForm from './Forms/NonInvestmentAccountForm';
import RealEstateAssetForm from './Forms/RealEstateAssetForm';
import BusinessAssetForm from './Forms/BusinessAssetForm';
import MiscAssetForm from './Forms/MiscAssetForm';
import DeferredCompensationForm from './Forms/DeferredCompensationForm';

export default props => {
  let typeName = '';

  if (!isNil(props.account.AccountType)) {
    typeName = props.accountTypesDictionary[props.account.AccountType];

    switch (props.account.AccountType) {
      case 0: // Bank Account: Checking
      case 1: // Bank Account: Savings
      case 2: // Bank Account: Certificate of Deposit
      case 8: // Credit Card
      case 13: // Mortgage
      case 14: // Loan: Installment
      case 15: // Loan: Line of Credit
      case 16: // Loan: Student Loan
      case 29: // Loan: Auto Loan
        return <NonInvestmentAccountForm {...props} typeName={typeName} />;
      case 23: // Investment Holding: 401 (a)
      case 4: // Investment Holding: 401 (k)
      case 10: // Investment Holding: 403 (b)
      case 11: // Investment Holding: 457 Plan
      case 6: // Investment Holding: 529 Plan
      case 12: // Investment Holding: Annuity
      case 27: // Investment Holding: Employer Plan
      case 21: // Investment Holding: Health Savings Account
      case 5: // Investment Holding: IRA
      case 25: // Investment Holding: Inherited IRA
      case 26: // Investment Holding: Inherited Roth IRA
      case 22: // Investment Holding: Roth 401(k)
      case 7: // Investment Holding: Roth IRA
      case 17: // Investment Holding: SEP IRA
      case 19: // Investment Holding: SIMPLE IRA
      case 3: // Investment Holding: Taxable Investment
      case 28: // Investment Holding: Tax Free Account
      case 30: // Investment Holding: Tax Deferred Account
      case 31: // Investment Holding: Donor Advised Fund
        return <InvestmentAccountForm {...props} typeName={typeName} />;
      default:
    }
  } else if (!isNil(props.account.OtherAssetType)) {
    typeName = props.otherAssetTypesDictionary[props.account.OtherAssetType];

    switch (props.account.OtherAssetType) {
      case 0: // Business Asset
        return <BusinessAssetForm {...props} typeName={typeName} />;
      case 1: // Real Estate Asset
        return <RealEstateAssetForm {...props} typeName={typeName} />;
      case 3: // Misc Asset
        return <MiscAssetForm {...props} typeName={typeName} />;
      case 4: // Deferred Compensation
        return <DeferredCompensationForm {...props} typeName={typeName} />;
      default:
    }
  }

  return null;
};
